import React from "react";
import UiDatePicker from "../UiDatePicker/DatePicker";
import UiDropDown from "../UiDropDown/DropDown";
import TextInput from "../UiTextInput/TextInput";
import { useCallback } from "react";
import { useState } from "react";
import { Select } from "antd";
import DeleteIcon from "../../images/Icon/close.png";

export const ColumnFilter = ({
  column,
  filter_type,
  data,
  onSearch,
  fieldName,
  columnsDto,
  countryData,
  loadAllDataList,
  getPincodeList,
  getSalesManagerList,
  getSalesExecutiveList,
  getServicingBranchList,
  rmList,
  roleTypeList,
}) => {
  const { filterValue, setFilter } = column;

  // for dto list save purpose
  const [pincode, setPincode] = useState([]);
  const [salesManagerList, setSalesManagerList] = useState([]);
  const [salesExecutiveList, setSalesExecutiveList] = useState([]);
  const [servicingBranchList, setServicingBranchList] = useState([]);

  // for loading purpose
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [salesManagerLoading, setSalesManagerLoading] = useState(false);
  const [salesExecutiveLoading, setSalesExecutiveLoading] = useState(false);
  const [servicingBranchLoading, setServicingBranchLoading] = useState(false);

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  const handleChange = (value, column) => {
    onSearch(value ? value : "", column);
    // setFilter(value);
  };

  const optimizedFn = useCallback(debounce(handleChange), []);

  const onClear = () => {
    setFilter("");
    optimizedFn("", column);
  };

  const closeIcon = (props) => {
    return (
      <img
        className="close__icon__select"
        src={DeleteIcon}
        alt="icon"
        height={10}
        width={10}
      />
    );
  };

  switch (filter_type) {
    case "TEXT":
    case "NUMBER":
      return (
        <TextInput
          value={filterValue}
          suffix={
            <img
              onClick={() => {
                onClear();
              }}
              className={filterValue ? "" : "listing__close__icon"}
              src={DeleteIcon}
              alt="icon"
              height={10}
              width={10}
            />
          }
          onChange={(e) => {
            optimizedFn(e.target.value, column);
            // onSearch(e.target.value, column);
            setFilter(e.target.value);
          }}
          className="listing-input-text"
        />
      );
    case "DROPDOWN":
    case "SEARCH_DROPDOWN":
      if (fieldName === "countryOfStudy") {
        return (
          <>
            <Select
              style={{
                width: "100%",
              }}
              placeholder="search country"
              allowClear
              options={countryData}
              showSearch={true}
              onClear={onClear}
              value={filterValue}
              onChange={(e) => {
                optimizedFn(e, column);
                setFilter(e);
              }}
              optionFilterProp="label"
              notFoundContent={null}
              clearIcon={closeIcon}
            />
          </>
        );
      } else if (fieldName === "roleType") {
        return (
          <>
            <Select
              style={{
                width: "100%",
              }}
              placeholder="Search role In partner portal"
              allowClear
              options={roleTypeList}
              showSearch={true}
              onClear={onClear}
              value={filterValue}
              onChange={(e) => {
                optimizedFn(e, column);
                setFilter(e);
              }}
              optionFilterProp="label"
              notFoundContent={null}
              clearIcon={closeIcon}
            />
          </>
        );
      } else if (fieldName === "assignedRmUserName") {
        return (
          <>
            <Select
              style={{
                width: "100%",
              }}
              placeholder="select RM Assigned"
              allowClear
              options={rmList}
              showSearch={true}
              onClear={onClear}
              value={filterValue}
              onChange={(e) => {
                optimizedFn(e, column);
                setFilter(e);
              }}
              optionFilterProp="label"
              notFoundContent={null}
              clearIcon={closeIcon}
            />
          </>
        );
      } else if (fieldName === "leadPincode") {
        return (
          <>
            <Select
              style={{
                width: "100%",
              }}
              placeholder="Type 3 digits"
              allowClear
              loading={pincodeLoading}
              options={pincode}
              showSearch={true}
              onClear={onClear}
              value={filterValue}
              onSearch={(e) =>
                loadAllDataList(
                  e,
                  setPincode,
                  setPincodeLoading,
                  getPincodeList,
                  "pincode",
                  "pincodeId"
                )
              }
              onChange={(e) => {
                optimizedFn(e?.value, column);
                setFilter(e);
              }}
              labelInValue
              notFoundContent={null}
              optionFilterProp="label"
              clearIcon={closeIcon}
            />
          </>
        );
      } else if (fieldName === "currentSmUserName") {
        return (
          <>
            <Select
              style={{
                width: "100%",
              }}
              placeholder="Type 3 letters"
              allowClear
              loading={salesManagerLoading}
              options={salesManagerList}
              showSearch={true}
              onClear={onClear}
              value={filterValue}
              onSearch={(e) =>
                loadAllDataList(
                  e,
                  setSalesManagerList,
                  setSalesManagerLoading,
                  getSalesManagerList,
                  "name",
                  "userId"
                )
              }
              onChange={(e) => {
                optimizedFn(e?.value, column);
                setFilter(e);
              }}
              labelInValue
              notFoundContent={null}
              optionFilterProp="label"
              clearIcon={closeIcon}
            />
          </>
        );
      } else if (fieldName === "currentSeUserName") {
        return (
          <>
            <Select
              style={{
                width: "100%",
              }}
              placeholder="Type 3 letters"
              allowClear
              loading={salesExecutiveLoading}
              options={salesExecutiveList}
              showSearch={true}
              onClear={onClear}
              value={filterValue}
              onSearch={(e) =>
                loadAllDataList(
                  e,
                  setSalesExecutiveList,
                  setSalesExecutiveLoading,
                  getSalesExecutiveList,
                  "name",
                  "userId"
                )
              }
              onChange={(e) => {
                optimizedFn(e?.value, column);
                setFilter(e);
              }}
              labelInValue
              notFoundContent={null}
              optionFilterProp="label"
              clearIcon={closeIcon}
            />
          </>
        );
      } else if (
        fieldName === "assignedAvanseBranchName" ||
        fieldName === "assignedAvanseBranchId"
      ) {
        return (
          <>
            <Select
              style={{
                width: "100%",
              }}
              placeholder="Type 3 letters"
              allowClear
              loading={servicingBranchLoading}
              options={servicingBranchList}
              showSearch={true}
              onClear={onClear}
              value={filterValue}
              onSearch={(e) =>
                loadAllDataList(
                  e,
                  setServicingBranchList,
                  setServicingBranchLoading,
                  getServicingBranchList,
                  "name",
                  "id"
                )
              }
              onChange={(e) => {
                optimizedFn(e?.value, column);
                setFilter(e);
              }}
              labelInValue
              notFoundContent={null}
              optionFilterProp="label"
              clearIcon={closeIcon}
            />
          </>
        );
      } else {
        return (
          <Select
            style={{
              width: "100%",
            }}
            placeholder="Select"
            allowClear
            options={data}
            showSearch={true}
            // onClear={onClear}
            value={filterValue}
            onChange={(e) => {
              // optimizedFn(e, column);
              setFilter(e);
            }}
            optionFilterProp="label"
            notFoundContent={null}
            clearIcon={closeIcon}
          />
          // <UiDropDown
          //   data={data}
          //   value={filterValue || ""}
          //   onChange={(e) => setFilter(e)}
          //   className={"column-dd-filter"}
          //   placeholder=""
          // />
        );
      }
    case "DATE":
      return (
        <UiDatePicker
          value={filterValue || ""}
          format={"DD/MM/YYYY"}
          className="listing-date-picker"
          onChange={(e) => {
            if (e) {
              onSearch(new Date(e).getTime(), column);
              setFilter(e);
            } else {
              onSearch("", column);
              setFilter("");
            }
          }}
        />
      );
    default:
      return null;
  }
};
